import React from "react";
//
import { motion } from "framer-motion";
//
/**
 * 逐渐不透明的动画; 逐渐消失的动画
 *
 * @component 逐渐不透明的动画; 逐渐消失的动画
 * @param {string} title - 逐渐不透明的动画
 * @param {string} content - 逐渐不透明的动画
 * @returns {JSX.Element} - 返回包含标题和内容的 JSX 元素
 */
//
export default function Opaque(props) {
  //
  const {children, duration=1, delay=0} = props
  // 我们定义了一个名为 opacityVariants 的对象，其中包含了动画的起始状态和结束状态。
  const opacityVariants = {
    opaque: { opacity: 0,},      // 从透明状态
    transparent: { opacity: 1,}, // 到不透明状态
  };
  return (
    <motion.div
      variants={opacityVariants}   // 使用定义的动画状态
      initial="opaque"             // 初始状态为不透明
      animate="transparent"        // 动画结束后变为透明
      transition={{ duration, delay, }} // 动画过渡时间为默认1秒, 延迟默认0秒
    >
      {children}
    </motion.div>
  );
}
